import React, { useEffect, useState } from 'react';
import {
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBTypography,
  MDBSpinner,
  MDBBtn,
  MDBInput,
  MDBRow,
  MDBCol,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBCheckbox
} from 'mdb-react-ui-kit';

function OrderTab({ user }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOption, setSortOption] = useState('order_date');
  const [showActiveOnly, setShowActiveOnly] = useState(false);

  const [createFixedModal, setCreateFixedModal] = useState(false);
  const toggleShowFixed = () => setCreateFixedModal(!createFixedModal);

  const [createCustomModal, setCreateCustomModal] = useState(false);
  const toggleShowCustom = () => setCreateCustomModal(!createCustomModal);


  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);





  const openOrderDetails = async (order) => {
    try {

      const customerRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/customers/get-customer/${order.customer_id}`);
      if (!customerRes.ok) throw new Error('Customer not found');
      const customerData = await customerRes.json();

      const detailsRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/order-details/get-order-detail-by-order-no/${order.order_no}`);
      if (!detailsRes.ok) throw new Error('Order Detail not found');
      const detailsData = await detailsRes.json();

      const orderDetails = Array.isArray(detailsData) ? detailsData : [detailsData];

      const bomRes = await fetch("https://krizkhen-floral-design.onrender.com/api/bom/get-all-bom");
      const allBom = await bomRes.json();

      const inventoryRes = await fetch("https://krizkhen-floral-design.onrender.com/api/inventory/get-all-inventory");
      const inventory = await inventoryRes.json();

      let allMaterials = [];

      orderDetails.forEach(detail => {
        const matchingBom = allBom.filter(b => b.product_no === detail.product_no);
        const materials = matchingBom.map(bom => {
          const inv = inventory.find(item => item.product_no === bom.material_no);
          return {
            description: inv?.description || "Unknown Material",
            quantity: bom.quantity * detail.quantity,
            product_no: detail.product_no
          };
        });
        allMaterials = [...allMaterials, ...materials];
      });


      const mergedMaterials = allMaterials.reduce((acc, item) => {
        const existing = acc.find(m => m.description === item.description);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          acc.push({ ...item });
        }
        return acc;
      }, []);


      setSelectedOrder({
        ...order,
        customer: customerData,
        materials: mergedMaterials
      });

      setShowModal(true);

    } catch (error) {
      console.error('Failed to fetch order details:', error);
    }
  };



  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };









  const [formData, setFormData] = useState({
    customer_name: '',
    contact_no: '',
    product_no: '',
    pickup_date: '',
    quantity: 1,
    selectedProducts: {},

    budget: 0,
    preferences: '',
    selectedInventory: {},
  });


  const [formError, setFormError] = useState('');
  const [products, setProducts] = useState([]);
  const [inventory, setInventory] = useState([]);

  const fetchProducts = async () => {
    try {
      const res = await fetch('https://krizkhen-floral-design.onrender.com/api/products/get-all-products');
    if (!res.ok) throw new Error('Failed to fetch products');
      const data = await res.json();
      setProducts(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchInventory = async () => {
    try {
      const res = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/get-all-inventory');
    if (!res.ok) throw new Error('Failed to fetch inventory');
      const data = await res.json();
      setInventory(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://krizkhen-floral-design.onrender.com/api/orders/get-all-orders');
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      const data = await res.json();
      setOrders(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchInventory();
    fetchOrders();
  }, []);

    
  const handleCreateFixedOrder = async () => {
    setFormError("");

    const { customer_name, contact_no, pickup_date, selectedProducts } = formData;

    if (!customer_name || !contact_no || !pickup_date || !selectedProducts || Object.keys(selectedProducts).length === 0) {
      setFormError("Please fill in all fields and select at least one product.");
      return;
    }

    try {
      const customerRes = await fetch("https://krizkhen-floral-design.onrender.com/api/customers/create-customer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customer_name, contact_no }),
      });

      const customerData = await customerRes.json();
      if (!customerRes.ok) throw new Error(customerData.error || "Failed to create customer");

      const orderNum = `ORD${Date.now().toString().slice(-6)}`;

      let totalAmount = 0;
      let orderStatus = "";

      const today = new Date();
      const pickup = new Date(pickup_date);
      const isSameDay =
        pickup.getFullYear() === today.getFullYear() &&
        pickup.getMonth() === today.getMonth() &&
        pickup.getDate() === today.getDate();

      orderStatus = isSameDay ? "Pending" : "Reserved";

      for (const product_no of Object.keys(selectedProducts)) {
        const quantity = selectedProducts[product_no];


        const productRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/products/get-product/${product_no}`);
        const productData = await productRes.json();
        if (!productRes.ok) throw new Error(productData.error || "Failed to fetch product");

        const productSubtotal = productData.price * quantity;
        totalAmount += productSubtotal;

        const bomRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/bom/get-bom-by-product/${product_no}`);
        const bomData = await bomRes.json();
        if (!bomRes.ok) throw new Error(bomData.error || "Failed to fetch BOM");

        for (const item of bomData) {
          const total_required_qty = item.quantity * quantity;

          const invRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/inventory/get-inventory/${item.material_no}`);
          const invData = await invRes.json();
          if (!invRes.ok) throw new Error(invData.error || "Failed to fetch inventory");

          const available_qty = invData.total_qty - invData.reserved_qty;

          if (available_qty < total_required_qty) {
            setFormError(`Not enough stock for material ${item.material_no}`);
            return;
          }

          if (!isSameDay) {
            const reserveRes = await fetch("https://krizkhen-floral-design.onrender.com/api/inventory/reserve-stock", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                product_no: item.material_no,
                quantity: total_required_qty,
              }),
            });

            const reserveData = await reserveRes.json();
            if (!reserveRes.ok) throw new Error(reserveData.error || "Inventory update failed");
          }
        }
      }

      const orderRes = await fetch("https://krizkhen-floral-design.onrender.com/api/orders/create-fixed-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          order_no: orderNum,
          customer_id: customerData.customer_id,
          pickup_date,
          type: "Fixed",
          status: orderStatus,
          quantity: 0, 
          total_amount: totalAmount,
          created_by: user?.firstname + " " + user?.lastname || "System",
        }),
      });

      const orderData = await orderRes.json();
      if (!orderRes.ok) throw new Error(orderData.error || "Failed to create order");

      for (const product_no of Object.keys(selectedProducts)) {
        const quantity = selectedProducts[product_no];

        const productRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/products/get-product/${product_no}`);
        const productData = await productRes.json();
        const subtotal = productData.price * quantity;

        const orderDetailRes = await fetch("https://krizkhen-floral-design.onrender.com/api/order-details/create-order-detail",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              order_no: orderNum,
              product_no,
              quantity,
              subtotal,
            }),
          }
        );

        const orderDetailData = await orderDetailRes.json();
        if (!orderDetailRes.ok) throw new Error(orderDetailData.error);
      }

      fetchOrders();
      toggleShowFixed();
      setFormData({
        customer_name: "",
        contact_no: "",
        pickup_date: "",
        selectedProducts: {},
      });
    } catch (err) {
      setFormError(err.message);
    }
  };














  const handleCreateCustomOrder = async () => {
    setFormError('');

    const { customer_name, contact_no, pickup_date, budget, preferences, selectedInventory } = formData;

    if (!customer_name || !contact_no || !pickup_date || !budget || !preferences || !selectedInventory || Object.keys(selectedInventory).length === 0) {
      setFormError('Please fill in all fields and select at least one inventory item.');
      return;
    }

    try {

      const customerRes = await fetch('https://krizkhen-floral-design.onrender.com/api/customers/create-customer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_name, contact_no }),
      });

      const customerData = await customerRes.json();
      if (!customerRes.ok) throw new Error(customerData.error || 'Failed to create customer');



      var totalMaterialCost = 0;
      var orderStatus = ''

      for (const product_no of Object.keys(selectedInventory)) {
        const qty = selectedInventory[product_no];

        const invRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/inventory/get-inventory/${product_no}`);
        const invData = await invRes.json();
        if (!invRes.ok) throw new Error(invData.error || 'Failed to fetch inventory');

        const available_qty = invData.total_qty - invData.reserved_qty;

        if (available_qty < qty) {
          setFormError(`Not enough stock for ${invData.product_name}`);
          return;
        }
        
        totalMaterialCost += invData.unit_cost * qty;

      }

      if (totalMaterialCost > budget) {
        setFormError(`Total material cost ₱${totalMaterialCost.toFixed(2)} exceeds budget ₱${budget}`);
        return;
      }
      




      for (const product_no of Object.keys(selectedInventory)) {
        const qty = selectedInventory[product_no];

        const today = new Date();
        const pickup = new Date(pickup_date);


        if (
          pickup.getFullYear() === today.getFullYear() &&
          pickup.getMonth() === today.getMonth() &&
          pickup.getDate() === today.getDate()
        ) {
          orderStatus = 'Pending';
        } else {
          orderStatus = 'Reserved'

          const reserveRes = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/reserve-stock', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              product_no: product_no,
              quantity: qty,
            }),
          });

          const reserveData = await reserveRes.json();
          if (!reserveRes.ok) throw new Error(reserveData.error || 'Inventory update failed');
        }
      }


      const customProductNo = `C${Math.floor(100 + Math.random() * 900)}`;
      const orderNum = `ORD${Date.now().toString().slice(-6)}`;

      const orderRes = await fetch('https://krizkhen-floral-design.onrender.com/api/orders/create-custom-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_no: orderNum,
          customer_id: customerData.customer_id,
          type: 'Custom',
          status: orderStatus,
          total_amount: budget,
          quantity: 1,
          preferences: preferences,
          pickup_date,
          created_by: user?.firstname + ' ' + user?.lastname || 'System',
        }),
      });

      const orderData = await orderRes.json();
      if (!orderRes.ok) throw new Error(orderData.error || 'Failed to create order');


      for (const product_no of Object.keys(selectedInventory)) {
        const qty = selectedInventory[product_no];

        await fetch('https://krizkhen-floral-design.onrender.com/api/bom/create-bom', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            product_no: customProductNo, 
            material_no: product_no,
            quantity: qty,
          }),
        });
      }


      const orderDetailRes = await fetch('https://krizkhen-floral-design.onrender.com/api/order-details/create-order-detail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_no: orderNum, 
          product_no: customProductNo,
          quantity: 1, 
          subtotal: budget
        }),
      });

      const orderDetailData = await orderDetailRes.json();
      if (!orderDetailRes.ok) throw new Error(orderDetailData.error || 'Failed to create order');







      fetchOrders();
      toggleShowCustom();
      setFormData({ customer_name: '', contact_no: '', product_no: '', pickup_date: '', quantity: 1, budget: 0, preferences: '', selectedInventory: {}, selectedProducts: {} });
    } catch (err) {
      setFormError(err.message);
    }
  };






















  const handleCompleteOrder = async (id, order_no, status) => {

    const orderDetailRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/order-details/get-order-detail-by-order-no/${order_no}`);
    if (!orderDetailRes.ok) throw new Error('Failed to fetch order details');
    const orderDetails = await orderDetailRes.json();

    for (const detail of orderDetails) {
      const bomRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/bom/get-bom-by-product/${detail.product_no}`);
      if (!bomRes.ok) throw new Error('Failed to fetch BOM');
      const bomData = await bomRes.json();

      for (const item of bomData) {
        const total_quantity = item.quantity * detail.quantity;
        const invRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/inventory/get-inventory/${item.material_no}`);
        if (!invRes.ok) throw new Error('Failed to fetch inventory'); await invRes.json();

        if (status === 'Reserved') {
          const removeRes = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/remove-reserve-stock', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ product_no: item.material_no, quantity: total_quantity }),
          });
          
          if (!removeRes.ok) throw new Error('Failed to remove reserved stock');
          await removeRes.json();
        }

        const removeRes = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/remove-stock', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_no: item.material_no, quantity: total_quantity }),
        });
        
        if (!removeRes.ok) throw new Error('Failed to remove stock');
        await removeRes.json();

        const soldRes = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/sold-qty', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_no: item.material_no, quantity: total_quantity }),
        });
        
        if (!soldRes.ok) throw new Error('Failed to update sold quantity');
        await soldRes.json();
      }
    }


    try {
      const res = await fetch(`https://krizkhen-floral-design.onrender.com/api/orders/complete-order/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to complete order');

      fetchOrders();
    } catch (err) {
      setError(err.message);
    }
  };





  const handleCancelOrder = async (id, order_no, status, type) => {
    try {
      const orderDetailRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/order-details/get-order-detail-by-order-no/${order_no}`);
      if (!orderDetailRes.ok) throw new Error('Failed to fetch order details');
      const orderDetails = await orderDetailRes.json();

      for (const detail of orderDetails) {
        let bomData;

        if (type === 'Fixed') {
          const productRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/products/get-product/${detail.product_no}`);
          if (!productRes.ok) throw new Error('Failed to fetch product');
          const productData = await productRes.json();

          const bomRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/bom/get-bom-by-product/${productData.product_no}`);
          if (!bomRes.ok) throw new Error('Failed to fetch BOM');
          bomData = await bomRes.json();
        }

        if (type === 'Custom') {
          const bomRes = await fetch(`https://krizkhen-floral-design.onrender.com/api/bom/get-bom-by-product/${detail.product_no}`);
          if (!bomRes.ok) throw new Error('Failed to fetch BOM');
          bomData = await bomRes.json();
        }

        for (const item of bomData) {
          const total_quantity = item.quantity * detail.quantity;

          if (status === 'Reserved') {
            const removeRes = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/remove-reserve-stock', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ product_no: item.material_no, quantity: total_quantity }),
            });
            if (!removeRes.ok) throw new Error('Failed to remove reserved stock');
            await removeRes.json();
          }
        }
      }

      const res = await fetch(`https://krizkhen-floral-design.onrender.com/api/orders/cancel-order/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!res.ok) throw new Error('Failed to cancel order');
      await res.json();

      fetchOrders();

    } catch (err) {
      setError(err.message);
      console.error(err);
    }
  };










  const sortedOrders = [...orders].sort((a, b) => {
    if (sortOption === 'order_date') return new Date(b.order_date) - new Date(a.order_date);
    if (sortOption === 'pickup_date') return new Date(a.pickup_date) - new Date(b.pickup_date);
    if (sortOption === 'status') return a.status.localeCompare(b.status);
    return a[sortOption] > b[sortOption] ? 1 : -1;
  });

  const filteredOrders = showActiveOnly
    ? sortedOrders.filter(order => order.status === 'Pending' || order.status === 'Reserved')
    : sortedOrders;

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <MDBSpinner role="status">
          <span className="visually-hidden">Loading...</span>
        </MDBSpinner>
      </div>
    );
  }

  if (error) {
    return (
      <MDBTypography tag="p" className="text-danger text-center mt-4">
        Error: {error}
      </MDBTypography>
    );
  }

  return (
    <div className="mt-4 w-100">

      {/* Title + Sort + Create Button */}
      <MDBRow className="align-items-center mb-4">
        <MDBCol>
          <MDBTypography tag="h1" className="custom-font" style={{ color: '#A78D79' }}>
            Orders
          </MDBTypography>
        </MDBCol>

        <MDBCol md="auto" className="ms-auto">
          <div className="d-flex align-items-center justify-content-end flex-wrap gap-3 w-100">
            <div className="d-flex align-items-center gap-2 flex-nowrap">


              <MDBTypography className="mb-0 me-2" style={{ whiteSpace: 'nowrap' }}>
                Sort by:
              </MDBTypography>


              <select
                className="form-select"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                style={{ width: 'auto' }}
              >
                <option value="order_no">Order No</option>
                <option value="order_date">Order Date</option>
                <option value="pickup_date">Pickup Date</option>
                <option value="status">Status</option>
              </select>
            </div>

            <div className="d-flex align-items-center gap-2 me-4">
              <MDBCheckbox
                id="showActiveOnly"
                label="Only Show Active"
                checked={showActiveOnly}
                onChange={(e) => setShowActiveOnly(e.target.checked)}
              />
            </div>
            

            {user?.role === 'admin' || user?.role === 'staff' ? (
              <MDBBtn style={{ backgroundColor: '#A78D79' }} onClick={toggleShowFixed}>
                CREATE FIXED ORDER
              </MDBBtn>
            ) : null}

            {user?.role === 'admin' ? (
              <MDBBtn style={{ backgroundColor: '#A78D79' }} onClick={toggleShowCustom}>
                CREATE CUSTOM ORDER
              </MDBBtn>
            ) : null}
          </div>
        </MDBCol>
      </MDBRow>

      {/* Orders Table */}
      <div className="mt-4" style={{ width: '100%', overflowX: 'auto' }}>
        <MDBTable bordered hover responsive>
          <MDBTableHead>
            <tr>
              <th>Order No</th>
              <th>Customer ID</th>
              <th>Type</th>
              <th>Status</th>
              <th>Order Date</th>
              <th>Pickup Date</th>
              <th>Created By</th>
              <th>Total Amount</th>
              <th style={{ width: '140px', paddingRight: '0.5rem' }}>Actions</th>
            </tr>
          </MDBTableHead>


        
          <MDBTableBody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <tr
                  key={order._id}
                  onClick={() => openOrderDetails(order)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{order.order_no}</td>
                  <td>{order.customer_id}</td>
                  <td>{order.type}</td>
                  <td>{order.status}</td>
                  <td>{new Date(order.order_date).toLocaleDateString()}</td>
                  <td>{new Date(order.pickup_date).toLocaleDateString()}</td>
                  <td>{order.created_by}</td>
                  <td>₱{order.total_amount?.toFixed(2)}</td>
                  
                  <td>
                    {(order.status === 'Pending' || order.status === 'Reserved') && (
                      <div className="d-flex gap-2" onClick={(e) => e.stopPropagation()}>
                        <MDBBtn
                          color="success"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCompleteOrder(order._id, order.order_no, order.status);
                          }}
                        >
                          Complete
                        </MDBBtn>

                        <MDBBtn
                          color="danger"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCancelOrder(order._id, order.order_no, order.status, order.type);
                          }}
                        >
                          Cancel
                        </MDBBtn>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No orders found
                </td>
              </tr>
            )}
          </MDBTableBody>


        </MDBTable>
      </div>



      {/* Create Fixed Order Modal */}
      <MDBModal open={createFixedModal} tabIndex="-1">
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Create Fixed Order</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={toggleShowFixed}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody>
              {/* Customer Info */}
              <MDBTypography tag="label" className="fw-bold mb-2">
                Customer Info
              </MDBTypography>
              <MDBInput
                className="mb-3"
                label="Customer Name"
                value={formData.customer_name}
                onChange={(e) =>
                  setFormData({ ...formData, customer_name: e.target.value })
                }
              />
              <MDBInput
                className="mb-3"
                label="Contact Number"
                value={formData.contact_no}
                onChange={(e) =>
                  setFormData({ ...formData, contact_no: e.target.value })
                }
              />


              {/* Product Selection */}
              <MDBTypography tag="label" className="fw-bold mb-2">
                Product Detail
              </MDBTypography>

              {/* Pickup Date */}
              <MDBInput
                className="mb-3"
                label="Pickup Date"
                type="date"
                value={formData.pickup_date}
                onChange={(e) =>
                  setFormData({ ...formData, pickup_date: e.target.value })
                }
              />

              <MDBTypography tag="label" className="fw-bold mb-2">
                Select Product
              </MDBTypography>
            

              {products
                .filter((p) => p.status === "Active")
                .sort((a, b) => a.product_name.localeCompare(b.product_name))
                .map((p) => (
                  <div
                    key={p.product_no}
                    className="d-flex align-items-center mb-2 gap-3"
                  >
                    {/* Checkbox */}
                    <input
                      type="checkbox"
                      checked={!!formData.selectedProducts?.[p.product_no]}
                      onChange={(e) => {
                        const selectedProducts = { ...formData.selectedProducts };

                        if (e.target.checked) {
                          selectedProducts[p.product_no] =
                            selectedProducts[p.product_no] || 1; 
                        } else {
                          delete selectedProducts[p.product_no];
                        }

                        setFormData({ ...formData, selectedProducts });
                      }}
                    />

                    {/* Product Name */}
                    <span>
                      {p.product_name} ({p.product_no})
                    </span>

                    {/* Quantity Input (only if selected) */}
                    {formData.selectedProducts?.[p.product_no] && (
                      <input
                        type="number"
                        min="1"
                        value={formData.selectedProducts[p.product_no]}
                        onChange={(e) => {
                          const selectedProducts = { ...formData.selectedProducts };
                          selectedProducts[p.product_no] =
                            parseInt(e.target.value) || 1;

                          setFormData({ ...formData, selectedProducts });
                        }}
                        style={{ width: "60px" }}
                      />
                    )}
                  </div>
                ))}

              {formError && <p className="text-danger small mb-0">{formError}</p>}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="danger" onClick={toggleShowFixed}>Cancel</MDBBtn>
              <MDBBtn color="success" onClick={handleCreateFixedOrder}>Create</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>





      {/* Create Custom Order Modal */}
      <MDBModal open={createCustomModal} tabIndex="-1">
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Create Custom Order</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={toggleShowCustom}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody>
              {/* Customer Info */}
              <MDBTypography tag="label" className="fw-bold mb-2">
                Customer Info
              </MDBTypography>
              <MDBInput
                className="mb-3"
                label="Customer Name"
                value={formData.customer_name}
                onChange={(e) =>
                  setFormData({ ...formData, customer_name: e.target.value })
                }
              />
              <MDBInput
                className="mb-3"
                label="Contact Number"
                value={formData.contact_no}
                onChange={(e) =>
                  setFormData({ ...formData, contact_no: e.target.value })
                }
              />

              {/* Product Selection */}
              <MDBTypography tag="label" className="fw-bold mb-2">
                Product Detail
              </MDBTypography>

              <MDBRow className="mb-3">
                <MDBCol>
                  <MDBInput
                    label="Budget"
                    type="number"
                    min="0"
                    value={formData.budget || 0}
                    onChange={(e) =>
                      setFormData({ ...formData, budget: parseInt(e.target.value) })
                    }
                  />
                </MDBCol>
                
                <MDBCol>
                  <MDBInput
                    label="Preferences"
                    value={formData.preferences || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, preferences: e.target.value })
                    }
                  />
                </MDBCol>
              </MDBRow>

              {/* Pickup Date */}
              <MDBInput
                className="mb-3"
                label="Pickup Date"
                type="date"
                value={formData.pickup_date}
                onChange={(e) =>
                  setFormData({ ...formData, pickup_date: e.target.value })
                }
              />


              {/* Inventory Selection */}
              <MDBTypography tag="label" className="fw-bold mb-2">
                Select Inventory
              </MDBTypography>
              {[...inventory].sort((a, b) => a.description.localeCompare(b.description)).map((item) => (
                <div key={item.product_no} className="d-flex align-items-center mb-2 gap-3">
                  
                  <input
                    type="checkbox"
                    checked={!!formData.selectedInventory?.[item.product_no]}
                    onChange={(e) => {
                      const selectedInventory = { ...(formData.selectedInventory || {}) };

                      if (e.target.checked) {
                        selectedInventory[item.product_no] =
                          selectedInventory[item.product_no] || 1;
                      } else {
                        delete selectedInventory[item.product_no];
                      }

                      setFormData({ ...formData, selectedInventory });
                    }}
                  />

                  <span>{item.description} ({item.product_no})</span>

                  {formData.selectedInventory?.[item.product_no] && (
                    <input
                      type="number"
                      min="1"
                      value={formData.selectedInventory?.[item.product_no]}
                      onChange={(e) => {
                        const selectedInventory = { ...(formData.selectedInventory || {}) };
                        selectedInventory[item.product_no] =
                          parseInt(e.target.value) || 1;
                        setFormData({ ...formData, selectedInventory });
                      }}
                      style={{ width: '60px' }}
                    />
                  )}
                </div>
              ))}




              {formError && <p className="text-danger small mb-0">{formError}</p>}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="danger" onClick={toggleShowCustom}>Cancel</MDBBtn>
              <MDBBtn color="success" onClick={handleCreateCustomOrder}>Create</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>


      {/* Show Order Modal */}
      <MDBModal open={showModal} tabIndex="-1">
        <MDBModalDialog centered>
          {selectedOrder && (
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle> <strong> {selectedOrder.order_no}</strong> </MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={closeModal}></MDBBtn>
              </MDBModalHeader>

              <MDBModalBody>
                <MDBRow>
                  {/* Order Detail Column */}
                  <MDBCol md={6}>
                    <MDBTypography tag="label" style={{fontSize: '1.2rem'}} className="fw-bold mb-2">Order Detail</MDBTypography>
                    <div className="mb-1"><strong>Type:</strong> {selectedOrder.type}</div>
                    <div className="mb-1"><strong>Status:</strong> {selectedOrder.status}</div>
                    <div className="mb-1"><strong>Order Date:</strong> {new Date(selectedOrder.order_date).toLocaleDateString()}</div>
                    <div className="mb-1"><strong>Pickup Date:</strong> {new Date(selectedOrder.pickup_date).toLocaleDateString()}</div>
                    <div className="mb-1"><strong>Created By:</strong> {selectedOrder.created_by}</div>
                    <div className="mb-1"><strong>Total Amount:</strong> ₱{selectedOrder.total_amount?.toFixed(2)}</div>
                    {selectedOrder.type === 'Custom' && (<div className="mb-1"><strong>Type:</strong> {selectedOrder.preferences}</div>)}
                  </MDBCol>

                  {/* Customer Detail Column */}
                  <MDBCol md={6}>
                    <MDBTypography tag="label" style={{fontSize: '1.2rem'}} className="fw-bold mb-2">Customer Detail</MDBTypography>
                    <div className="mb-1"><strong>Customer Name:</strong> {selectedOrder.customer.customer_name}</div>
                    <div className="mb-1"><strong>Contact No:</strong> {selectedOrder.customer.contact_no}</div>
                    <div className="mb-1"><strong>Customer ID:</strong> {selectedOrder.customer.customer_id}</div>
                  </MDBCol>
                </MDBRow>

                <MDBRow className="mt-4">
                  <MDBCol>
                    <MDBTypography tag="label" style={{ fontSize: '1.2rem' }} className="fw-bold mb-2">
                      Materials Needed
                    </MDBTypography>

                    {selectedOrder.materials.length > 0 ? (
                      <ul>
                        {selectedOrder.materials.map((item, index) => (
                          <li key={index}>
                            {item.quantity} {item.description}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div>No materials found.</div>
                    )}
                  </MDBCol>
                </MDBRow>
              </MDBModalBody>
            </MDBModalContent>
          )}

        </MDBModalDialog>
      </MDBModal>



    </div>
  );
}

export default OrderTab;
